import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DeviceUsageType } from 'src/app/features/tests/features/constants';
import { DEVICE_USAGE_CONFIG } from './helper';



@Component({
  selector: 'app-device-usage-indicator',
  templateUrl: './usage-indicator.component.html',
  styleUrl: './usage-indicator.component.scss',
  imports: [CommonModule, MatIconModule]
})
export class AppDeviseUsageIndicatorComponent {
  @Input() usageType: DeviceUsageType = DeviceUsageType.IN_LAB;

  config = DEVICE_USAGE_CONFIG;

  get current() {
    return this.config[this.usageType] || { label: this.usageType, class: '' };
  }
}
